import script from "./StatCard.vue?vue&type=script&setup=true&lang=js"
export * from "./StatCard.vue?vue&type=script&setup=true&lang=js"

import "./StatCard.vue?vue&type=style&index=0&id=14b15fe5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14b15fe5"]])

export default __exports__